import { render, staticRenderFns } from "./ProcessQuestion.vue?vue&type=template&id=e08bd730&scoped=true"
import script from "./ProcessQuestion.vue?vue&type=script&lang=js"
export * from "./ProcessQuestion.vue?vue&type=script&lang=js"
import style0 from "./ProcessQuestion.vue?vue&type=style&index=0&id=e08bd730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08bd730",
  null
  
)

export default component.exports